import script from "./BrandPortfolioStrategyMixin.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioStrategyMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__